var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scrap)?_c('div',{staticClass:"detail-bdi",class:{'detail-bdi-row': _vm.showType === 'row', 'detail-bdi-column': _vm.showType === 'column'}},[_c('div',[_c('div',{staticClass:"t-info-text"},[_vm._v("审批记录")]),_c('record',{attrs:{"record-list":_vm.scrap && _vm.scrap.statusActionRecord ? _vm.scrap.statusActionRecord : []}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }